import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useIntl } from 'react-intl';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { TargetAccumulatorSwitch } from '@/App/tiles/TargetAccumulator/TargetAccumulatorSwitch';
import { useUserContext } from '@/context/UserContext.tsx';
import { type ClientsWay, DEFAULT_CLIENTS_WAY, POSSIBLE_CLIENTS_WAY } from '@/store/targetAccumulator/state.ts';

export const ClientWay = () => {
  const tileId = useTargetAccumulatorTileId();
  const {
    currentUser: { userType },
  } = useUserContext();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const isInternalSales = userType === 'Internal Sales';
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();
  const { formatMessage } = useIntl();
  const clientsWay = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.clientsWay);
  const currencyPair = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.currencyPair);
  const [currency1] = currencyPair?.split('/') ?? [];

  const handleChangeClientWay = (value: ClientsWay) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'Client way changed', isDefined(value) ? value : 'cleared');

    return checkTargetAccumulatorWithTradeCapture({
      clientsWay: value,
    });
  };

  function formatClientsWay(value: ClientsWay): string {
    return formatMessage(
      {
        id: `targetAccumulator.form.clientsWay.${value}`,
      },
      { currency: currency1 },
    );
  }

  return (
    <TargetAccumulatorFormField
      formattedMessageId="targetAccumulator.form.clientsWay"
      formattedMessageValues={{ isInternalSales }}
    >
      <TargetAccumulatorSwitch<ClientsWay>
        name="client-way"
        identifier={tileId}
        values={POSSIBLE_CLIENTS_WAY}
        selectedValue={clientsWay ?? DEFAULT_CLIENTS_WAY}
        onChange={handleChangeClientWay}
        formatValue={formatClientsWay}
      />
    </TargetAccumulatorFormField>
  );
};
